// Copyright 2025 Sorama B.V.

import { autoinject } from "aurelia-dependency-injection";
import { BindingEngine, computedFrom, Disposable } from "aurelia-framework";
import { ReportableMeasurement } from "datatypes/ReportableMeasurement";
import { MeasurementTypeDisplayNames } from "datatypes/SorXFormat";
import { SorXMeasurement } from "datatypes/SorXMeasurement";
import { IModal } from "libraries/WorkflowFramework/Interfaces/IModal";

/**
 * Allows for previewing a report
 */
@autoinject
export class PreviewMeasurementModal implements IModal<PreviewMeasurementModalState> {
    protected measurement: ReportableMeasurement<SorXMeasurement> | null = null;

    private disposables: Disposable[] = [];

    @computedFrom("measurement")
    protected get measurementTypeDisplayName(): string {
        return MeasurementTypeDisplayNames[this.measurement?.data?.type] ?? "Unknown";
    }

    constructor(private readonly bindingEngine: BindingEngine) {}

    public activateModal(state: PreviewMeasurementModalState) {
        this.measurement = state.report;
    }

    public deactivate(): void {
        // Clean up all disposables when modal is closed
        this.disposables.forEach((disposable) => disposable.dispose());
        this.disposables = [];
    }
}
// This needs to be on the bottom for it to work
export class PreviewMeasurementModalState {
    report: ReportableMeasurement<SorXMeasurement>;
}
